import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatDialogModule,
	MatGridListModule,
	MatTableModule,
	MatIconModule,
	MatInputModule,
	MatListModule,
	MatMenuModule,
	MatProgressBarModule,
	MatProgressSpinnerModule, MatSelectModule,
	MatSliderModule,
	MatTabsModule,
	MatSortModule,
	MatSnackBarModule, MatToolbarModule,
	MatTooltipModule, MatSidenavModule, MatCheckboxModule, MatFormFieldModule
} from '@angular/material';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from "@angular/flex-layout";

@NgModule({
    imports: [
        MatButtonModule,
        MatMenuModule,
		MatTabsModule,
        MatIconModule,
        MatCardModule,
        MatSliderModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatInputModule,
        MatGridListModule,
		MatTableModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatListModule,
        MatDialogModule,
		MatSelectModule,
		MatToolbarModule,
		MatSidenavModule,
		FlexLayoutModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatSortModule,
    ],
    exports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatCardModule,
        MatSliderModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatInputModule,
        MatGridListModule,
		MatTableModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatListModule,
        MatDialogModule,
		MatSelectModule,
		MatTabsModule,
		MatToolbarModule,
		MatSidenavModule,
		FlexLayoutModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatSortModule,
    ],
})

export class MaterialModule {

}